export const sizeUnitFor = (areaTypes: { id: number | null; sizeUnit?: string | null }[], areaTypeId: number | null | undefined) =>
  areaTypes.find(a => a.id === areaTypeId)?.sizeUnit ?? '';

// A blank/whitespace-only unit must never render as a dangling "€/".
export const perUnitLabel = (unit: string | null | undefined) => (unit?.trim() ? `€/${unit.trim()}` : '€');
